import React from "react"
import { useEffect, useState } from "react"
import { HOTEL_TAXONOMY_VERANDA_GRAND_BAIE_ID, HOTEL_TAXONOMY_VERANDA_PALMAR_BEACH_ID, HOTEL_TAXONOMY_VERANDA_PAUL_VIRGINIE_ID, HOTEL_TAXONOMY_VERANDA_POINTE_AUX_BICHES_ID, HOTEL_TAXONOMY_VERANDA_TAMARIN_ID } from "../../constants"

const Logo = ({ hotelId, locale }) => {
  // Get Mobile
  const window1 = typeof window !== "undefined" ? window : ""

  const [width, setWidth] = useState(window1.innerWidth)

  function handleWindowSizeChange() {
    setWidth(window1.innerWidth)
  }
  useEffect(() => {
    window1.addEventListener("resize", handleWindowSizeChange)
    return () => {
      window1.removeEventListener("resize", handleWindowSizeChange)
    }
  }, [])

  switch (hotelId) {
    case HOTEL_TAXONOMY_VERANDA_POINTE_AUX_BICHES_ID:
      return locale === "fr" ? (
        <span className="icon-logo-pointe-aux-biches-fr">
        </span>
      ) : (
        <span className="icon-logo-pointe-aux-biches-en">
        </span>
      )
    case HOTEL_TAXONOMY_VERANDA_TAMARIN_ID:
      return locale === "fr" ? (
        <span className="icon-logo-tamarin-fr">
        </span>
      ) : (
        <span className="icon-logo-tamarin-en">
        </span>
      )
    case HOTEL_TAXONOMY_VERANDA_PALMAR_BEACH_ID:
      return locale === "fr" ? (
        <span className="icon-logo-palmar-fr">
        </span>
      ) : (
        <span className="icon-logo-palmar-en">
        </span>
      )
    case HOTEL_TAXONOMY_VERANDA_GRAND_BAIE_ID:
      return locale === "fr" ? (
        <span className="icon-logo-grandbaie-fr">
        </span>
      ) : (
        <span className="icon-logo-grandbaie-en">
        </span>
      )
    case HOTEL_TAXONOMY_VERANDA_PAUL_VIRGINIE_ID:
      return locale === "fr" ? (
        <span className="icon-logo-paul-et-virginie-fr">
        </span>
      ) : (
        <span className="icon-logo-paul-et-virginie-en">
        </span>
      )
    default:
      return locale === "fr" ? (
        <span className="icon-logo-veranda-resorts-fr">
        </span>
      ) : (
        <span className="icon-logo-veranda-resorts-en">
        </span>
      )
  }
}

export default Logo
